<template>
  <el-dialog
    :model-value="dialogFlag"
    title="订单信息"
    :center="true"
    :close-on-click-modal="false"
    @close="$emit('closeDialog')"
  >
    <el-table :data="content.orders" style="width: 90%; margin: auto">
      <el-table-column prop="trade_no" label="订单号" width="150" />
      <el-table-column prop="address" label="房屋地址" width="200" />
      <el-table-column prop="city" label="城市" width="75" />
      <el-table-column prop="housetype" label="房屋类型" width="100" />
      <el-table-column prop="area" label="面积" width="75" />
      <el-table-column prop="email" label="联系邮箱" width="150" />
      <el-table-column prop="phone" label="联系电话" width="150" />
    </el-table>
    <el-alert
      type="error"
      title="付款后24小时内客服会发送报告至您的手机，客服电话：021-68828928 17302155893（微信kuaishen002）QQ: 3450306099 E-mail: 3450306099@qq.com"
      center
      show-icon
      style="margin-top: 25px"
    ></el-alert>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="$emit('closeDialog')" type="">取消</el-button>
        <el-button type="primary" @click="$emit('closeDialog')"
          >确认</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { ElButton, ElDialog, ElTable, ElTableColumn, ElAlert } from "element-plus";
export default {
  name: "OrderDialog",
  data() {
    return {};
  },
  emits: ['closeDialog'],
  props: {
    dialogFlag: {
      type: Boolean,
    },
    content: {
      type: Object,
      default() {
        return {
          msg: "未知错误,请联系客服",
          orders: [],
        };
      },
    },
  },
  components: { ElButton, ElDialog, ElTable, ElTableColumn, ElAlert },
};
</script>
<style lang="less"></style>
